import styled from 'styled-components';
import { Form } from 'react-bootstrap';
import { theme } from '../../../theme';

export const DivTitle = styled.div`
  margin-bottom: 0.615rem;
  font-size: 1rem;
  font-weight: 600;
  color: ${theme.colors.textPrimary};
`;

export const FormCheck = styled(Form.Check)`
    &.form-check {
        position: relative;
        margin-bottom: 0.615rem;
        color: ${theme.colors.textDisabled};
        width: fit-content;
        cursor: pointer;
    
        input {
            opacity: 0;
            cursor: pointer;
        }
        
        label {
            padding-left: 0.615rem;
            font-size: 0.923rem;
          font-weight: 500;
          color: ${theme.colors.textPrimary};
          cursor: pointer;
        }
        
        &::before {
            position: absolute;
            content: '';
            top: 0.154rem;
            left: 0;
            width: 1.078rem;
            height: 1.078rem;
            border: 1px solid ${theme.colors.textDisabled};
            border-radius: 100%;
        }
    }
    
    &.form-check:not(.has-inner-block):last-child {
        margin-bottom: 1.846rem;
    }
 
    &.form-check.active {
        &::before {
            border: 5px solid ${theme.colors.active};
        }
        
        label {
              font-weight: 600;
        }
    }

      &.form-check.disabled {
        cursor: not-allowed;

        input {
          cursor: not-allowed;
        }

        &::before {
          border-color: ${theme.colors.textDisabled};
        }
    
        label {
          color: ${theme.colors.textDisabled};
          cursor: not-allowed;
        }
      }
}
`;
